import type { EaGefahr } from "./types";

/**
 * Abschnitt 4 „Versicherte Gefahren – KBU-Status“ der Felddefinition.
 *
 * Der Status je Gefahr kommt aus den DSI-Feldern `*_O`:
 *   0 = nicht versichert · 1 = versichert ohne KBU · 2 = versichert mit KBU
 */
export const KBU_STATUS_OPTIONS: ReadonlyArray<{
  value: "0" | "1" | "2";
  label: string;
  short: string;
  hint: string;
}> = [
  {
    value: "0",
    label: "Nicht versichert",
    short: "0",
    hint: "Die Gefahr ist im Sachvertrag nicht gedeckt.",
  },
  {
    value: "1",
    label: "Versichert ohne KBU",
    short: "1",
    hint: "Sachschaden gedeckt, Ertragsausfall daraus jedoch nicht.",
  },
  {
    value: "2",
    label: "Versichert mit KBU",
    short: "2",
    hint: "Sachschaden und der daraus folgende Ertragsausfall sind gedeckt.",
  },
];

export const EA_GEFAHREN: ReadonlyArray<EaGefahr> = [
  { key: "feuer", label: "Feuer inkl. Überspannung", dsi: "FEUER_O" },
  { key: "ed", label: "Einbruchdiebstahl / Raub / Vandalismus", dsi: "ED_O" },
  { key: "lw", label: "Leitungswasser / Sprinklerleckage", dsi: "LW_O" },
  { key: "sturm", label: "Sturm / Hagel", dsi: "STURM_O" },
  { key: "elem", label: "Weitere Elementargefahren", dsi: "ELEM_O" },
  { key: "tg", label: "Technische Gefahren", dsi: "TG_O" },
  { key: "pg", label: "Weitere / sonstige Gefahrengruppe laut DSI", dsi: "PG_O" },
  { key: "fra", label: "Fahrzeuganprall / Rauch / Überschalldruckwellen", dsi: "FRA_O" },
  { key: "unbgef", label: "Unbenannte Gefahren", dsi: "UNBGEF_O" },
];

/**
 * „Gefahren ohne KBU“ (Excel-Zeile 36): automatische Liste aller Gefahren mit
 * Status 1 — versichert, aber ohne Betriebsunterbrechungsdeckung. Die bestehende
 * Logik im Bestand bleibt damit erhalten.
 */
export const gefahrenOhneKbu = (
  kbu: Record<string, string>,
): ReadonlyArray<EaGefahr> => EA_GEFAHREN.filter((g) => kbu[g.key] === "1");
